import UsersPermissionsContainer from "../../../features/user/UsersPermissionsContainer";
import { anyPermission, CLASSROOM_PERMISSIONS, hasPermission, PermissionId } from "../../../app/permissions";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/user/userSlice";

interface ClassroomUsersListProps {
  schoolId: string;
  classroomId: string;
}

const ClassroomUsersList = ({ schoolId, classroomId }: ClassroomUsersListProps) => {
    const user = useSelector(selectUser);
    const perm: boolean = hasPermission(user.priza.info, PermissionId.SCHOOL_ADMIN, schoolId)
            || anyPermission(user.priza.info, classroomId, [ PermissionId.CLASSROOM_ADMIN, PermissionId.CLASSROOM_TEACHER ]);
    return <UsersPermissionsContainer
        canGrantPermission={perm}
        targetId={classroomId}
        permissions={CLASSROOM_PERMISSIONS}
        messages={{
        title: "Professores",
        empty: "Ninguém associado a esta sala de aula.",
        }}
    />;

};

export default ClassroomUsersList;